import { cameraApiRequest } from './cameraApiRequest';

/**
 * Deletes a clip (its bank item, softly): 204. Needs `cameras_manage`.
 */
export const deleteCameraClip = ({
  projectId,
  cameraId,
  clipId,
  activeEmployerInfo,
}) =>
  cameraApiRequest({
    method: 'DELETE',
    apiPath: `projects/${projectId}/cameras/${cameraId}/clips/${clipId}`,
    activeEmployerInfo,
  });
